<!--
Settings screen
@author bmk11u, ab557z
TODO : STOP MUTATING PROP
-->
<template>
  <div id="contain" class="container">
    <Nav name="Settings" :step="true" />
    <div>
      <div style="border-bottom:1px solid #e4e4e4;padding-bottom:24px;">
        <p style="margin-left:24px;color:#003865;font-size:18px;margin-top:24px;font-weight:700;">Push Notifications</p>
            <span for="push" style="padding-left:24px;font-size:18px;color:#4F5961">Late Timetable Change</span>
            <ToggleButton name="LATE_CHANGE_NOTIFICATION" :toggle="displaySetting['LATE_CHANGE_NOTIFICATION']"
            />
      </div>
      <div>
        <p style="margin-left:24px;color:#003865;font-size:18px;margin-top:24px;font-weight:700;">SMS Notifications</p>
            <label for="sms" style="padding-left:24px;font-size:18px;color:#4F5961">Late Timetable Change</label>
            <ToggleButton name="LATE_CHANGE_SMS" :toggle="displaySetting['LATE_CHANGE_SMS']"
            />
      </div>
    </div>
    <div id="pusher"></div>
    <Footer active="settings"/>
  </div>
</template>

<script setup>
//Utilities
import {ref, onMounted } from 'vue'
import axios from 'axios'

//Components
import ToggleButton from '@/components/ToggleButton.vue'
import Footer from '@/components/FooterMenu.vue'

//Data
const value = ref({})
const displaySetting = ref({})
const settings = ref({})

onMounted(
  () => {
    // Fetch the sms setting from the the server. There are only 2 editable setting right now. DOESNT WORK
    axios.get('/timetable/settings')
      .then(response => {
        settings.value = response.data
        displaySetting.value = {}
        value.value = {}
        for (var i = 0; i < settings.value.length; i++) {
          if (settings.value[i].settingValue == 'Y') {
            displaySetting.value[settings.value[i].id.settingName] = true
          } else {
            displaySetting.value[settings.value[i].id.settingName] = false
          }
        }
        console.log(settings.value)
        console.log(displaySetting.value)
      })
  }
)
</script>

<style>
.settingBtn {
  margin-top:-2px;
  float:right;
}
.settingHdr {
  margin-top:10px;
  margin-left:12px;
  margin-bottom:0px;
  font-weight:bold;
  color:  #074C4C; /* #686868 */
}

.settingLi {
height:52px;
}
</style>
